// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Pdw0","title":"Info_title__1mv_r","links":"Info_links__i9YDG","link":"Info_link__2niZB","logo":"Info_logo__3ntML"};